<template>
  <div class="col-12 grid-margin">
    <div
      id="loadingmessage"
      style="
        text-align: center;
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: white;
        z-index: 30001;
        opacity: 0.8;
      "
      v-if="loading"
    >
      <p style="position: absolute; color: White; top: 40%; left: 50%">
        <img src="../../assets/loader.gif" />
      </p>
    </div>
    <div v-if="isstat" class="card">
      <div class="card-body">
        <h4 class="card-title">Edit a Blog</h4>
        <form class="form-sample" @submit="onSubmit">
          <div class="col-md-6 pt-4 pb-4 pl-0">
            <div class="row">
              <div
                class="col-md-6 form-group"
                style="font-size: 16px !important"
              >
                <label for="exampleInputEmail1">Please Upload Blog Image</label>
                <br />

                <input
                  type="file"
                  class="images"
                  accept="image/*"
                  id="file"
                  ref="file"
                  v-on:change="handleFileUpload()"
                />
                <p v-if="url">{{ data.image }}</p>

                <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
              </div>
              <div class="col-md-4">
                <div width="80px" height="80px" id="preview">
                  <img width="100%" height="100%" :src="url" />
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="font-size: 16px !important">
            <div class="col-md-4 pb-2">
              <b-form-group label="Title">
                <b-form-input
                  type="text"
                  v-model="title"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-8 pb-2">
              <!-- <b-form-group label="Text">
                <b-form-textarea
                  type="text"
                  v-model="text"
                  required
                   rows="5"
                ></b-form-textarea>
              </b-form-group> -->
              <froala  id="edit" :tag="'textarea'" v-model="text"></froala>
            </div>
            <hr class="pt-2" />
          </div>
          <hr />
          <b-button variant="primary" class="btn-fw" type="submit"
            >Submit</b-button
          >
        </form>
      </div>
    </div>
    <div v-else>
      <b>Sorry!!Please Try Again Later or Do a Refresh!!</b>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "editblog",
  props: ["id"],
  data: () => {
    return {
      loading: false,
      sci_name: "",
      data: [],
      title: "",
      text: "",
      image: "",
      loading: false,
      previewurl: "http://13.232.14.77/u/",
      file: "",
      url: null,
      urlarr: [],
      turt: new FormData(),
      selectedFiles: null,
      isstat: false,
      immarr: [],
    };
  },
  mounted: function () {
    this.getDetails();
  },
  methods: {
    onFileChanged2(event) {
      this.selectedFiles = event.target.files[0];
      this.turt.append("image", this.selectedFiles);
      var img;
      img = new Image();
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = () => {
        const urls = URL.createObjectURL(this.selectedFiles);
        if (this.urlarr.length < 4) {
          this.urlarr.push(urls);
        } else {
          this.seen = false;
          this.msg = "Four Images Already Addted!";
          this.showsnackbar = true;
        }

        // console.log( this.url1)
        // this.uploadImage();
      };
    },
    uploadImages() {
      this.turt.append("id", this.id);
      this.turt.append("image", this.file);
      console.log(this.turt);
      axios({
        method: "post",
        url: "/blog/imageupload",
        data: this.turt,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.loading = false;

            alert("Updated Successfully");

            this.$router.push({ path: "/blogList" });
          }
          if (response.data.status === false) {
            this.loading = false;
            // alert("Image upload failed..please Try Again");
            // window.location.reload();
          }
        })

        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    getDetails() {
      this.loading = true;
      var data1 = {};
      data1["id"] = this.id;
      axios({
        method: "GET",
        url: "/blog/get?id=" + this.id,
        data: data1,
      })
        .then((response) => {
          this.loading = false;
          this.isstat = response.data.status;
          if (response.data.status === true) {
            this.data = response.data.data;
            this.title = this.data.title;
            this.text = this.data.text;
            if (response.data.data.image != null) {
              this.url = this.previewurl + this.data.image;
            }
            //   var temp=[]
            //   for(i=0;i<response.data.data.image.length;i++)
            //   {
            //     var ty=this.previewurl+response.data.data.image[i]
            //     temp.push(ty)
            //   }

            //  this.urlarr=temp
            // var temp={}
            // for(var j=0;j<response.data.data.image.length;j++)
            // {
            //   var ty=response.data.data.image[j]
            //   temp.push(ty)
            // }
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
          alert("Something went wrong");
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.url = URL.createObjectURL(this.file);
    },

    imgremove(index) {
      this.urlarr.splice(index, 1);
    },
    imgremove1(index) {
      this.imarr.splice(index, 1);
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.loading = true;
      var edit = {};
      edit["id"] = this.id;
      edit["x-auth-token"] = localStorage.getItem("token");
      edit["title"] = this.title;
      edit["text"] = this.text;
      axios({
        method: "post",
        url: "/blog/edit",
        data: edit,
      })
        .then((response) => {
          if (response.data.status === true) {
            this.uploadImages();
          }
          if (response.data.status === false) {
            this.loading = false;

            alert("please Try Again");
            this.$router.push({ path: "/editblog" });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>